import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ModuleSideNav from "../../shared/ModuleSideNav";
import { useColorMode } from "../../../contexts/ColorModeContext";
import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
  NAV_ITEMS,
} from "./navConfig";

const ICONS = {
  Dashboard: InsightsOutlinedIcon,
  ShoppingCart: LocalMallOutlinedIcon,
  RequestQuote: AssignmentOutlinedIcon,
  Inventory: CategoryOutlinedIcon,
  Notification: MarkEmailUnreadOutlinedIcon,
  Receipt: RequestPageOutlinedIcon,
  Car: LocalShippingOutlinedIcon,
  Wallet: PaymentsOutlinedIcon,
};

const ControladoriaMuiNav = (props) => {
  const { mode, toggleColorMode } = useColorMode();

  return (
    <ModuleSideNav
      moduleTitle="Controladoria"
      navItems={NAV_ITEMS}
      iconMap={ICONS}
      drawerWidth={DRAWER_WIDTH}
      drawerWidthCollapsed={DRAWER_WIDTH_COLLAPSED}
      mode={mode}
      toggleColorMode={toggleColorMode}
      {...props}
    />
  );
};

export default ControladoriaMuiNav;
